import script from "./PriorHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PriorHeader.vue?vue&type=script&setup=true&lang=js"

import "./PriorHeader.vue?vue&type=style&index=0&id=4ff52bfe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff52bfe"]])

export default __exports__